import React, {useEffect, useRef, useState} from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { clsx } from "clsx";
import ContentArea from "../ContentArea";
import ButtonBlock from "../ButtonBlock";
import MediaArea from "../MediaArea";

const TwoColumnLayout = ({ settings, blocks, props }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const { globals } = props;

  const layout = isMobile ? settings.layout_type_mobile : settings.layout_type;
  const imageWidth = isMobile ? settings.width_mobile : settings.width;
  const description = settings.content || '';
  const reverselayout = isMobile ? settings.reverse_layout_mobile : settings.reverse_layout;
  const classes = settings.classes || '';

  // Content and media alignment classes
  const contentAlignmentMobile = `text-${settings.content_alignment_mobile} items-${settings.content_alignment_mobile}`;
  const contentAlignmentDesktop = `lg:text-${settings.content_alignment_desktop} lg:items-${settings.content_alignment_desktop}`;
  const contentPositionClass = `justify-${isMobile ? 
    settings.content_position_mobile || 'center' : 
    settings.content_position_desktop || 'center'}`;

  return (
    <section className={`w-full ${classes} twi-${layout}`}>
      <div
        className={`twi-${layout}__container lg:h-[${settings.container_height}px] overflow-hidden relative`}
      >
        <div
          className={`twi-${layout}__content ${clsx({
            "flex-col": isMobile,
            "flex-col-reverse": isMobile && settings.reverse_layout_mobile,
            "flex-row-reverse": reverselayout,
          })}`}
        >
          <div
            className="twi-container"
            style={{
              flexBasis: `calc(${100 - parseFloat(imageWidth)}%)`,
            }}
          >
            <div
              className={`twi-${layout}__content gap-x-[20px]
          ${
            settings.padding_area == "inside" &&
            ` pt-[${settings.padding_top_mobile}px]` +
              ` lg:pt-[${settings.padding_top_desktop}px]` +
              ` pb-[${settings.padding_bottom_mobile}px]` +
              ` lg:pb-[${settings.padding_bottom_desktop}px]` +
              ` px-[${settings.padding_left_right_mobile}px]` +
              ` lg:px-[${settings.padding_left_right_desktop}px]`
          }
          ${clsx({
            "flex-col": isMobile,
            "flex-col-reverse": isMobile && settings.reverse_layout_mobile,
            "flex-row-reverse": reverselayout,
          })}`}
            >
              <div
                className={`twi-${layout}__data ${contentPositionClass} ${contentAlignmentMobile} ${contentAlignmentDesktop}`}
              >
                <ContentArea settings={settings} description={description} isMobile={isMobile} />
                <ButtonBlock blocks={blocks} settings={settings} />
              </div>
            </div>
          </div>

          <div
            className="flex flex-col justify-center space-y-4 lg:basis-1/2"
            style={{ flexBasis: imageWidth + "%" }}
          >
            <div className={`flex h-full w-full`}>
              <MediaArea globals={globals} settings={settings} isMobile={isMobile} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TwoColumnLayout;
